export default {
  packageConfigsList: 'Danh sách gói dịch vụ bán lẻ',
  packageConfigsCreate: 'Tạo gói dịch vụ bán lẻ',
  agencyPackageConfigsList: 'Các gói đang hoạt động',
  agencyPackageConfigsCreate: 'Đăng ký dùng thử',
  agencyPackageConfigsIncrease: 'Gia hạn',
  agencyPackageConfigsBuy: 'Mua',
  agencyPackageConfigsEdit: 'Sửa',
  agencyPackageConfigsGift: 'Tặng gói',
  detail: 'Chi tiết',
  agencyPackageOrderList: 'Quản lý đơn hàng',
  agCreate: {
    title: 'Thêm đại lý mua gói dịch vụ bán lẻ',
  },
  columns: {
    name: 'Tên gói',
    type: 'Loại gói',
    price: 'Giá bán',
    searchLimit: 'Giới hạn tìm kiếm',
    specialNote: 'Đã bao gồm gói duy trì Website',
    bookingLimit: 'Giới hạn đặt vé',
    issueLimit: 'Lượt xuất còn lại',
    paxLimit: 'Giới hạn số lượng khách đặt vé',
    enableQR: 'Cho phép QR',
    unit: 'Đơn vị',
    enableFilter: 'Cho phép lọc',
    feeTransaction: 'Phí tự động xuất vé',
    createdAt: 'Ngày tạo',

    updatedAt: 'Ngày sửa',
    isActive: 'Trạng thái',
    agency: 'Đại lý bán lẻ',
    parentAgency: 'Đại lý F2',
    packageConfig: 'Gói dịch vụ',
    packageConfigIssueLimit: 'Giới hạn xuất vé',
    monthsUse: 'Số tháng sử dụng',
    monthsExtra: 'Số tháng được khuyến mãi',
    expiredAt: 'Thời gian hết hạn',
    enable: 'Trạng thái',
    action: 'Thao tác',
    paymentMethod: 'Phương thức thanh toán',
    payment: 'Thanh toán',
    buyer: 'Đại lý mua',
    agencyRetail: 'Đại lý áp dụng',
    orderCode: 'Mã đơn hàng',
    totalAmountToBePaid: 'Tổng tiền sau khi giảm giá',
    totalPrice: 'Tổng tiền',
    searchCount: 'Số lượt đã tìm kiếm',
    issueCount: 'Số vé đã xuất',
    bookCount: 'Số vé đã đặt',
    periodStart: 'Từ ngày',
    periodEnd: 'Đến ngày',
    percentage: 'Giảm giá (%)',
    amountMax: 'Giá trị mã giảm giá',
    code: 'Mã giảm giá',
    isUsed: 'Đã sử dụng',
    totalDiscount: 'Tổng giảm giá',
    autoIssueTicket: 'Tự động xuất vé khi thanh toán',
    enableDraft: 'Hỗ trợ quản lý booking ảo',
    domain: 'domain',
    isExpired: 'Trạng thái',
    dateCreate: 'Ngày',
    paymentMethods: 'Phương thức thanh toán',
  },
  placeholder: {
    searchText: 'Tìm kiếm gói dịch vụ',
    agency: 'Đại lý F2',
  },
  buy: {
    title: 'Mua gói dịch vụ bán lẻ',
  },
  increase: {
    title: 'Gia hạn gói dịch vụ bán lẻ',
  },
  payment: {
    title: 'Thanh toán',
  },
  gift: {
    title: 'Tặng gói dịch vụ bán lẻ',
  },
  CREDIT: 'Công nợ',
  MONEY: 'Chuyển khoản',
  PENDING: 'Chưa thanh toán',
  DONE: 'Đã thanh toán',
  CANCELED: 'Đã huỷ',
  cancel: 'Huỷ đơn hàng',
  CANCEL: 'Hủy',
  coupon: {
    titleList: 'Danh sách mã giảm giá gói dịch vụ bản lẻ',
    create: 'Tạo',
    createCoupon: 'Tạo mã giảm giá',
  },
  addDomain: 'Thêm domain',
  expired: 'Đã hết hạn',
  unexpired: 'Chưa hết hạn',
  over: 'Quá hạn mức',
  notover: 'Còn hạn mức',
  all: 'Tất cả',
  history: {
    title: 'Số liệu sử dụng',
  },
  form: {
    create: 'Tạo gói bán lẻ',
    update: 'Sửa gói bán lẻ',
    name: 'Tên gói',
    price: 'Giá',
    unit: 'Đơn vị',
    searchLimit: 'Giới hạn tìm kiếm',
    bookingLimit: 'Giới hạn đặt vé',
    issueLimit: 'Giới hạn xuất vé',
    invoiceIssueLimit: 'Số lượng hoá đơn',
    invoiceFeeTransaction: 'Phí xuất hoá đơn',
    paxLimit: 'Giới hạn số lượng khách',
    enableQR: 'Bật QR',
    enableFilter: 'Bật bộ lọc',
    feeTransaction: 'Phí tự động xuất vé',
    isGift: 'Là quà tặng',
    type: 'Loại gói',
    exclusiveAgencies: 'Đại lý độc quyền',
    descriptions: 'Mô tả',
    paymentMethods: 'Phương thức thanh toán',
    placeholder: {
      name: 'Nhập tên',
      price: 'Nhập giá',
      unit: 'Nhập đơn vị',
      searchLimit: 'Nhập giới hạn tìm kiếm',
      bookingLimit: 'Nhập giới hạn đặt chỗ',
      issueLimit: 'Nhập giới hạn cấp phát',
      invoiceIssueLimit: 'Nhập số lượng hoá đơn',
      paxLimit: 'Nhập giới hạn khách',
      enableQR: 'Bật QR',
      enableFilter: 'Bật bộ lọc',
      feeTransaction: 'Nhập phí giao dịch',
      invoiceFeeTransaction: 'Nhập phí xuất hoá đơn',
      isGift: 'Chọn nếu là quà tặng',
      type: 'Chọn gói',
      exclusiveAgencies: 'Nhập đại lý độc quyền',
      descriptions: 'Nhập mô tả',
    },

    key: 'Key',
    description: 'Mô tả',
    value: 'Giá trị',
  },
  units: {
    MONTH: 'Tháng',
    YEAR: 'Năm',
    PACKAGE: 'Gói',
  },
  btn: {
    addDescription: 'Thêm mô tả',
  },
  noPeriod: 'Chưa có chi tiết sử dụng gói',
  packageDetails: 'Chi tiết gói',
  domainSettings: 'Cài đặt domain',
  packageUsageDetails: 'Chi tiết sử dụng gói',
  usageDetails: 'Chi tiết sử dụng',
  giftPackage: {
    multiLegSearch: 'Tìm kiếm nhiều chặng',
    searchBookInternationalFlightsQRPayment: 'Tìm kiếm và đặt chỗ quốc tế',
    QRPayment: 'Thanh toán QR',
    supportManagingVirtualBookings: 'Hỗ trợ quản lý booking ảo',
    automaticTicketIssuanceUponPayment: 'Tự động xuất vé khi thanh toán',
    banUnbanIndividualClientSuspiciousActivity: 'Ban/Unban IP Khách lẻ giao dịch bất thường',
    lookupBookedHeldFlightsOrders: 'Tra cứu chuyến bay/Đơn hàng đã đặt/giữ chỗ',
    manageReportsAndReceivables: 'Quản lý báo cáo, công nợ',
    manageListBookedTickets: 'Quản lý danh sách vé đặt',
    professionalTicketManagementSystemAgents: 'Hệ thống thao tác vé chuyên nghiệp cho đại lý',
    sendOrderConfirmationPaymentConfirmationEmails: 'Gửi email đơn hàng/Xác nhận thanh toán',
    manageServiceDeesTicketIssuanceFeesConfiguration: 'Quản lý cầu hình phí dịch vụ/Phí xuất vé',
    manageInvoiceRequestInformationVAT: 'Quản lý thông tin yêu cầu xuất Hóa đơn VAT',
    showNearbyDates: 'Hiển thị ngày lân cận',
    flightFiltersSortingOptions: 'Bộ lọc và sắp xếp chuyến bay',
    searchAndBookDomesticFlights: 'Tìm kiếm và đặt chỗ nội địa',
  },
  clearFilters: 'Xóa bộ lọc',
  discountBy: 'Giảm giá theo',
  delete: 'Xóa',
  Unused: 'Chưa sử dụng',
  total: 'Tổng',
  expiredCountDayBeforeExpiredDaysAgo: 'Đã hết hạn {countDayBeforeExpired} ngày',
  willExpireCountDayBeforeExpiredDays: 'Sẽ hết hạn sau {countDayBeforeExpired} ngày',
}
